import logo from './img/login/logo.png';
import loginImg from './img/login/login.png';
import loginBg from './img/login/bg.png';
// ---------------------------------------------------------
import userCenterImg from './img/map/user.png';
import voiceHomeImg from './img/map/voice.png';
import voiceCloseHomeImg from './img/map/voice-close.png';
import homeBg from './img/map/bg.png';
import homeNextBg from './img/map/next.png';
import homePrevBg from './img/map/prev.png';
// ---------------------------------------------------------
import BackImg from './img/explain/back.png';
import explainVoice from './img/explain/voice.png';
import explainMute from './img/explain/mute.png';
import explainAnimation from './img/explain/animation.png';
import explainRole from './img/explain/role.png';
import Skip from './img/explain/skip.png';
import explainBg from './img/explain/bg.png';
// ---------------------------------------------------------
import exerciseLogo from './img/exercises/logo.png';
import exercisesBg from './img/exercises/bg.png';
import exercisesModal from './img/exercises/modal-question.png';
import nextQuestion from './img/exercises/next.png';
import prevQuestion from './img/exercises/prev.png';
import error from './img/exercises/modal-error.png';
import success from './img/exercises/modal-success.png';
import complete from './img/exercises/modal-complete.png';
// ---------------------------------------------------------
import tips from './img/pay/tips-icon.png';
import payBg from './img/pay/pay-bg.png';
import payGoBack from './img/pay/goBack.png';
import productBg from './img/pay/checked-product-bg.png';
// ---------------------------------------------------------
import paySuccess from './img/pay/pay-success.png';
import payError from './img/pay/pay-error.png';
// ---------------------------------------------------------
import tpl from './img/pay/pay-tpl.png';
import payQrcode from './img/pay/pay-qrcode.png';
import payPcSuccess from './img/pay/pay-pc-success1.png';
// ---------------------------------------------------------
import certificateBg from './img/certificate/bg.png';
import certificateModal from './img/certificate/modal-bg.png';
// ---------------------------------------------------------
import userBg from './img/user/bg.png';
import userInfoBg from './img/user/user-bg.png';
const dataConfig = {
  // 登录页
  login: {
    title: '采购与供应链', // 课程名称
    logo, // 默认logo
    loginImg, // 登录页图片
    loginBg // 登录页背景图
  },
  // 主页地图
  home: {
    userCenterImg, // 个人中心
    voiceHomeImg, // 播放声音
    voiceCloseHomeImg, // 静音
    homeBg, // 主页背景图
    homeNextBg, // 下一页按钮背景
    homePrevBg // 上一页按钮背景
  },
  // 课程讲解页
  explain: {
    BackImg, // 返回按钮
    explainVoice, // 播放声音
    explainMute, // 静音
    explainAnimation, //
    explainRole, // 角色
    Skip, // 跳过
    explainBg // 背景图
  },
  // 练习页
  exercises: {
    BackImg, // 返回按钮
    exerciseLogo, // logo
    Skip, // 跳过
    exercisesBg, // 背景
    exercisesModal,
    nextQuestion, // 下一题
    prevQuestion, // 上一题
    error,
    success,
    complete
  },
  // 支付页
  pay: {
    title: '供应链需求管理-预测指南',
    tips,
    payBg,
    payGoBack,
    productBg
  },
  // 支付返回页
  payback: {
    paySuccess,
    payError
  },
  // 支付二维码页
  payqrcode: {
    tpl,
    payQrcode,
    payPcSuccess
  },
  // 证书页
  certificate: {
    BackImg,
    title: '采购与供应链',
    certificateBg,
    certificateModal
  },
  // 个人中心
  user: {
    BackImg,
    title: '采购与供应链',
    userBg,
    userInfoBg
  }
};

export default dataConfig
  ;
